import { RuleListStatus } from '@wix/rules-panel-ui';
import { atom } from 'jotai';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../consts';
import { AnalysisState } from '../hooks/rules-state';
import { isStaticPage } from '../rule-mappers/shared/helpers';
export const signedInstanceAtom = atom(undefined);
export const activeTabIdAtom = atom(ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS);
export const initialPageIdAtom = atom(undefined);
export const multiLingualDataAtom = atom(null);
export const colorsInSessionAtom = atom([]);
export const analyzeSiteTriggeredAtom = atom(false);
export const isApplyTriggeredAtom = atom(false);
export const scrollerNodeRefAtom = atom(null);
export const altTextScreenPageIdAtom = atom(undefined);
export const verticalsDrillInPageIdAtom = atom(undefined);
export const unsavedChangedHandlersAtom = atom(undefined);
export const inaccessibleComponentsSessionAtom = atom({});
export const inaccessibleComponentsSessionPagesAtom = atom([]);
export const inaccessibleLayoutSessionAtom = atom({});
export const inaccessibleLayoutSessionPagesAtom = atom([]);
export const panelStateAtom = atom({
  globalSectionComponentsDataMap: new Map(),
  groupsDataMap: new Map(),
  pagesData: new Map(),
  verticalsDrillInStateUpdate: new Set()
});
// this derived atom is relevant for phase 1 only (can be deleted once we stop grouping all vertical pages within single group)
export const pageIdByItemTypeAtom = atom(get => {
  const {
    groupsDataMap
  } = get(panelStateAtom);
  return new Map(Array.from(groupsDataMap.values()).filter(_ref => {
    let {
      itemType
    } = _ref;
    return !isStaticPage(itemType);
  }).map(groupData => [groupData.itemType, groupData.pageId]));
});
export const isScanningAtom = atom(get => {
  const {
    groupsDataMap
  } = get(panelStateAtom);
  return Array.from(groupsDataMap.values()).some(_ref2 => {
    let {
      analysisState
    } = _ref2;
    return analysisState === AnalysisState.Analyzing || analysisState === AnalysisState.FirstAnalyzing;
  });
});
export const totalIssuesCountAtom = atom(get => {
  const {
    groupsDataMap
  } = get(panelStateAtom);
  let total = 0;
  groupsDataMap.forEach(groupData => {
    if (groupData.analysisState !== AnalysisState.FirstAnalyzing && groupData.analysisState !== AnalysisState.Analyzing) {
      groupData.rulesStateMap.forEach(ruleState => {
        var _ruleState$state;
        if ((ruleState == null || (_ruleState$state = ruleState.state) == null ? void 0 : _ruleState$state.status) !== RuleListStatus.passed) {
          total++;
        }
      });
    }
  });
  return total;
});
export const totalRulesCountAtom = atom(get => {
  const {
    groupsDataMap
  } = get(panelStateAtom);
  let total = 0;
  groupsDataMap.forEach(groupData => {
    if (groupData.analysisState !== AnalysisState.FirstAnalyzing && groupData.analysisState !== AnalysisState.Analyzing) {
      total += groupData.rulesStateMap.size;
    }
  });
  return total;
});
export const totalPagesScannedAtomPhase1 = atom(get => {
  const {
    groupsDataMap
  } = get(panelStateAtom);
  let total = 0;
  groupsDataMap.forEach(groupData => {
    if (!groupData.isTpaPage && groupData.analysisState !== AnalysisState.Analyzing && groupData.analysisState !== AnalysisState.FirstAnalyzing) {
      total++;
    }
  });
  return total;
});
export const totalPagesScannedAtom = atom(get => {
  const {
    groupsDataMap
  } = get(panelStateAtom);
  let total = 0;
  groupsDataMap.forEach(groupData => {
    const isAnalyzing = groupData.analysisState === AnalysisState.Analyzing || groupData.analysisState === AnalysisState.FirstAnalyzing;
    if (groupData.isTpaPage) {
      total += groupData.scannedPages;
    } else if (!isAnalyzing && (isStaticPage(groupData.itemType) || groupData.itemType === undefined)) {
      total += 1;
    }
  });
  return total;
});
export const isReorganizingDomOrderAtom = atom(false);
export const rescanTriggerGroupIdAtom = atom(undefined);
export const crossPageColorContrastIssuesAtom = atom(new Set(), (get, set, newValues) => {
  const currentSet = get(crossPageColorContrastIssuesAtom);
  const valuesToAdd = Array.isArray(newValues) ? newValues : Array.from(newValues);
  const hasNewValues = valuesToAdd.some(value => !currentSet.has(value));
  if (hasNewValues) {
    const updatedSet = new Set([...currentSet, ...valuesToAdd]);
    set(crossPageColorContrastIssuesAtom, updatedSet);
  }
});
//# sourceMappingURL=session-atoms.js.map